export interface IconProps extends React.HTMLAttributes<HTMLOrSVGElement> {
  size?: number;
  color?: string;
  strokeWidth?: number;
  stroke?: string;
  width?: number | string;
  height?: number | string;
  fill?: string;
}

export const defaultIconProps: IconProps = {
  size: 20,
  color: 'currentColor',
  strokeWidth: 1.5,
};
